var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PaginationController", {
        ref: "historyTable",
        attrs: {
          getDataActionName: "getAuditRecords",
          historyLimit: _vm.historyLimit,
          haveStartDate: ""
        },
        scopedSlots: _vm._u([
          {
            key: "dataTable",
            fn: function() {
              return [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.auditRecords,
                    "item-key": "_key",
                    "hide-actions": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item._key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(
                                _vm.toTimestampString(props.item.createTime)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(
                                props.item.status === "done"
                                  ? _vm.toTimestampString(
                                      props.item.lastModifiedTime
                                    )
                                  : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(
                                Object.entries(props.item.upcs || {}).length
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.workerName))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(
                                (_vm.siteKeyMap.get(props.item.siteKey) || {})
                                  .siteName
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-xs-left",
                              staticStyle: {
                                "overflow-wrap": "break-word",
                                "white-space": "pre-wrap",
                                "max-width": "25vw",
                                "min-width": "15vw"
                              }
                            },
                            [_vm._v(_vm._s(props.item.note))]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  props.item.status === "pending"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary", flat: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.showEditAuditDialog(
                                                props.item
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("open")))]
                                      )
                                    : _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary", flat: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.showEditAuditDialog(
                                                props.item
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("details")))]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary", flat: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showEditNoteDialog(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("note")))]
                                  ),
                                  _vm._v(" "),
                                  props.item.status === "pending"
                                    ? _c("LoaderButton", {
                                        attrs: {
                                          buttonText: _vm.$t("close"),
                                          promiseAwait: _vm.confirmAudit,
                                          promiseItem: props.item,
                                          flat: ""
                                        }
                                      })
                                    : _c("v-flex")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                })
              ]
            },
            proxy: true
          },
          {
            key: "beforeMenu",
            fn: function() {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { dark: "", color: "primary" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.showAuditCreateDialog.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                    _vm._v(_vm._s(_vm.$t("newAudit")))
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.auditRecords,
          callback: function($$v) {
            _vm.auditRecords = $$v
          },
          expression: "auditRecords"
        }
      }),
      _vm._v(" "),
      _vm.showAuditEditPopup
        ? _c("WarehouseAuditEditPopup", {
            attrs: { initRecord: _vm.auditRecordInEdit },
            on: { onSubmitted: _vm.onEditAudit },
            model: {
              value: _vm.showAuditEditPopup,
              callback: function($$v) {
                _vm.showAuditEditPopup = $$v
              },
              expression: "showAuditEditPopup"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAuditCreatePopup
        ? _c("WarehouseAuditCreatePopup", {
            on: { onSubmitted: _vm.onCreateAudit },
            model: {
              value: _vm.showAuditCreatePopup,
              callback: function($$v) {
                _vm.showAuditCreatePopup = $$v
              },
              expression: "showAuditCreatePopup"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editNoteDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("editNote"),
              medium: "",
              rightMethod: _vm.editNote,
              rightButtonText: _vm.$t("submit")
            },
            on: {
              popupClose: function($event) {
                _vm.editNoteDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      label: _vm.$t("note"),
                                      outline: ""
                                    },
                                    model: {
                                      value: _vm.note,
                                      callback: function($$v) {
                                        _vm.note = $$v
                                      },
                                      expression: "note"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              615064569
            ),
            model: {
              value: _vm.editNoteDialog,
              callback: function($$v) {
                _vm.editNoteDialog = $$v
              },
              expression: "editNoteDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d1dd5f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d1dd5f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WarehouseAudit.vue
// module id = null
// module chunks = 